export class HrEmpFamilyDetail {
  ID: number;
  EmpCode: number;
  Name: string;
  DOB: Date;
  RelationId: number;
  Age: number;
  IncludeInsurance: boolean;
  RelationName: string;
  Deceased: boolean;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}

export class LeaveTypeDetails {
  Id: number;
  Name: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}
